import { render, staticRenderFns } from "./UpdateTip.vue?vue&type=template&id=3cbf772f&scoped=true&"
import script from "./UpdateTip.vue?vue&type=script&lang=js&"
export * from "./UpdateTip.vue?vue&type=script&lang=js&"
import style0 from "./UpdateTip.vue?vue&type=style&index=0&id=3cbf772f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbf772f",
  null
  
)

export default component.exports